// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#sidebar{position:fixed;left:0;transform:translateX(calc(-100% - 6px));transition:transform .475s ease-out;pointer-events:none;width:420px;max-width:100%;background-color:#fff;z-index:1001;font-size:1rem;box-shadow:0 3px 6px rgba(0,0,0,.16)}#sidebar.open{pointer-events:all;transform:translateX(0)}#sidebar>.io-sidebar-group>a{border-bottom:1px solid #ebebeb}#sidebar>.io-sidebar-group:last-child>a{border-bottom:0}", ""]);
// Exports
module.exports = exports;
